import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setLayoutDashboardTitle } from "../../../store/ui-slice";
import RemainingCustomerPackageDetailMain from "./component/RemainingCustomerPackageDetailMain";
import { useParams } from "react-router-dom";

const RemainingCustomerPackageDetailMainPage = () => {
  const { product_name } = useParams();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setLayoutDashboardTitle({ title: `Package Details` }));
  }, []);

  return <RemainingCustomerPackageDetailMain />;
};

export default RemainingCustomerPackageDetailMainPage;
